// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "78e7b23bd39e51b2a15a" + ".chunk.js";
};